<template>
  <div id="app" class="overflow-x-hidden">
    <app-header class="p2"></app-header>

    <main class="mt4 px2 clearfix">
      <router-view></router-view>
    </main>

    <!-- <app-footer class="p2"></app-footer> -->
  </div>
</template>

<script>
  import AppHeader from '@/components/partials/AppHeader'
  import AppFooter from '@/components/partials/AppFooter'

  export default {
    name: 'app',
    metaInfo: { title: 'Maich Swift Architects' },
    components: { AppHeader, AppFooter }
  }
</script>

<style>
  @import 'style/imports';
  @import 'style/global';
</style>



// WEBPACK FOOTER //
// src/App.vue